import React from 'react';
import { Link } from 'react-router-dom';
import { WhatsApp, SupportAgent } from '@mui/icons-material';
import './supportButton.css';

const WHATSAPP_DISPLAY = '+234 915 4978 790';
const WHATSAPP_LINK = 'https://wa.me/2349154978790?text=Hello%20WayaQuick%2C%20I%20need%20help%20with%20';


function SupportButton() {
    return (
        <aside className="wq-support" aria-label="Get help">
            <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="wq-support-btn wq-support-call wq-support-whatsapp"
                aria-label={`Chat with us on WhatsApp: ${WHATSAPP_DISPLAY}`}
            >
                <WhatsApp fontSize="small" aria-hidden="true" />
                <span className="wq-support-label">{WHATSAPP_DISPLAY}</span>
            </a>
            <Link to="/complaints" className="wq-support-btn wq-support-help" aria-label="Support">
                <SupportAgent fontSize="small" aria-hidden="true" />
                <span className="wq-support-label">Support</span>
            </Link>
        </aside>
    );
}

export default SupportButton;
